// extracted by mini-css-extract-plugin
module.exports = {"Color":"DrawerInstruments_Color__3Ele5","toggleContainer":"DrawerInstruments_toggleContainer__2zPAl"};